import { SuccessDialogContent, SuccessDialogContentProps } from '@components/display/dialogs';
import { CloseButton } from '@components/utility/buttons';
import { Dialog, DialogProps } from '@mui/material';
import { clsx } from 'clsx';

interface Props extends Omit<DialogProps, 'children'> {
    contentProps: SuccessDialogContentProps;
}

const GenericSuccessDialog = ({ contentProps, ...props }: Props) => {
    return (
        <Dialog {...props} classes={{ ...props.classes, paper: clsx('dialog-paper py-[40px]', props.classes?.paper) }}>
            <CloseButton onClick={() => props.onClose?.({}, 'backdropClick')} />
            <SuccessDialogContent {...contentProps} />
        </Dialog>
    );
};

export { GenericSuccessDialog };
